import hyphenate from "./hyphenate-style-name";
import validateKeyframesObject from "./validate-keyframes-object";
export function atomicSelector(id, pseudo) {
  let selector = ".".concat(id);
  if (pseudo) {
    selector += pseudo;
  }
  return selector;
}
export function keyframesToBlock(keyframes) {
  if (process.env.NODE_ENV !== "production") {
    validateKeyframesObject(keyframes);
  }
  if (process.env.NODE_ENV !== "production" && typeof Object.getPrototypeOf(keyframes) !== "undefined") {
    if (Object.getPrototypeOf(keyframes) !== Object.getPrototypeOf({})) {
      // eslint-disable-next-line no-console
      console.warn("Only plain objects should be used as animation values. Unexpectedly recieved:", keyframes);
    }
  }
  let result = "";
  for (const animationState in keyframes) {
    result += "".concat(animationState, "{").concat(declarationsToBlock(keyframes[animationState]), "}");
  }
  return result;
}
export function declarationsToBlock(style) {
  let css = "";
  for (const prop in style) {
    const val = style[prop];
    if (typeof val === "string" || typeof val === "number") {
      css += "".concat(hyphenate(prop), ":").concat(val, ";");
    }
  } // trim trailing semicolon

  return css.slice(0, -1);
}
export function keyframesBlockToRule(id, block) {
  return "@keyframes ".concat(id, "{").concat(block, "}");
}
export function fontFaceBlockToRule(id, block) {
  return "@font-face{font-family:".concat(id, ";").concat(block, "}");
}
export function styleBlockToRule(selector, block) {
  return "".concat(selector, "{").concat(block, "}");
}